export interface Testimonial {
  id: number;
  name: string;
  role: string;
  avatar: string;
  stars: number;
  title: string;
  text: string;
}

export const testimonials: Testimonial[] = [
  {
    id: 1,
    name: 'Алексей Петров',
    role: 'Москва, Россия',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20man%20in%20his%20late%2020s%20with%20light%20stubble%2C%20warm%20natural%20lighting%2C%20clean%20white%20background%2C%20friendly%20expression%2C%20modern%20casual%20style%2C%20high%20quality%20studio%20photography&width=80&height=80&seq=t-avatar-01&orientation=squarish',
    stars: 5,
    title: 'Лучший способ заказать',
    text: 'YOYBUY Sheet полностью изменил мой подход к заказам из Китая. Теперь я вижу все позиции в одной таблице и могу отслеживать каждый этап доставки. Экономия времени колоссальная!',
  },
  {
    id: 2,
    name: 'Мария Иванова',
    role: 'Санкт-Петербург',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20woman%20in%20her%20early%2030s%20with%20natural%20makeup%2C%20warm%20lighting%2C%20clean%20white%20background%2C%20confident%20smile%2C%20modern%20professional%20style%2C%20studio%20photography&width=80&height=80&seq=t-avatar-02&orientation=squarish',
    stars: 5,
    title: 'Экономия до 30%',
    text: 'Благодаря сравнению цен в YOYBUY Spreadsheet я экономлю около 30% на каждом заказе. Интерфейс интуитивно понятный, даже моя мама разобралась за 10 минут!',
  },
  {
    id: 3,
    name: 'Дмитрий Соколов',
    role: 'Новосибирск',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20man%20in%20his%20mid%2030s%20with%20short%20dark%20hair%2C%20warm%20studio%20lighting%2C%20clean%20white%20background%2C%20friendly%20expression%2C%20business%20casual%20style&width=80&height=80&seq=t-avatar-03&orientation=squarish',
    stars: 5,
    title: 'Прозрачность и контроль',
    text: 'Я заказываю товары для своего магазина, и YOYBUY Sheet даёт мне полный контроль над каждым заказом. Больше никаких потерянных позиций и путаницы со статусами.',
  },
  {
    id: 4,
    name: 'Екатерина Волкова',
    role: 'Казань',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20woman%20in%20her%20late%2020s%20with%20blonde%20hair%2C%20warm%20natural%20lighting%2C%20clean%20background%2C%20genuine%20smile%2C%20modern%20style%2C%20studio%20photography&width=80&height=80&seq=t-avatar-04&orientation=squarish',
    stars: 4,
    title: 'Удобно и надёжно',
    text: 'Пользуюсь YOYBUY Spreadsheet уже полгода. Система работает как часы — все заказы структурированы, статусы обновляются вовремя. Очень рекомендую всем!',
  },
  {
    id: 5,
    name: 'Андрей Кузнецов',
    role: 'Екатеринбург',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20man%20in%20his%20early%2040s%20with%20salt%20and%20pepper%20hair%2C%20warm%20studio%20lighting%2C%20clean%20white%20background%2C%20confident%20expression%2C%20professional%20style&width=80&height=80&seq=t-avatar-05&orientation=squarish',
    stars: 5,
    title: 'Лучше обычных приложений',
    text: 'Перешёл с мобильного приложения на YOYBUY Sheet и не пожалел. Spreadsheet-формат оказался гораздо удобнее — видно всё сразу, можно сортировать и фильтровать.',
  },
  {
    id: 6,
    name: 'Ольга Морозова',
    role: 'Краснодар',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20woman%20in%20her%20mid%2030s%20with%20dark%20hair%2C%20warm%20natural%20lighting%2C%20clean%20background%2C%20friendly%20smile%2C%20casual%20modern%20style&width=80&height=80&seq=t-avatar-06&orientation=squarish',
    stars: 4,
    title: 'Отличная поддержка',
    text: 'Когда у меня возник вопрос по доставке, поддержка ответила в течение часа. YOYBUY Sheet — это не просто таблица, это целая экосистема для заказов из Китая.',
  },
];